export const ROUTE_PATH = {
  HOME_PAGE: '/',
  STUDY_SUMMARY: '/study-summary',
  POPULATION_PAGE: '/population',
  QNQ_PAGE: '/qnq',
  GROUPING_PAGE: '/grouping',
  SURVEY_PAGE: '/survey',
  CREATE_SURVEY: '/create-survey',
  RISE_SURVEY_PAGE: '/rise/survey',
  RISE_SURVEY_DETAILS_PAGE: '/rise/survey/surveydetails',
  CREATE_RISE_SURVEY: '/rise/create-survey',
  NOTIFICATION_PAGE: '/notification',
  RISE_NOTIFICATION_PAGE: '/rise/notification',
  NOTIFICATION_DETAIL_PAGE: '/notification-detail',
  RISE_NOTIFICATION_DETAIL_PAGE: '/rise/notification-detail',
  CREATE_NOTIFICATION: '/configure-notification',
  CREATE_RISE_NOTIFICATION: '/rise/configure-notification',
  QRE_PAGE: '/qre',
  ANALYTICS_PAGE: '/analytics',
  NOT_FOUND_PAGE: '/not-found',

  RND_SURVEY_DASHBOARD_PAGE: '/rnd-dashboard',

  BUSINESS_COMPONENT_PAGE: '/business-component',

  ORBIT_PAGE: '/orbit',
};

export function getRoutePathWithStudyPeriod(routePath, studyPeriod) {
  if (studyPeriod === undefined) return routePath;
  return `/${studyPeriod}${routePath}`;
}

export function getRoutePathWithStudyPeriodPlaceholder(routePath) {
  return getRoutePathWithStudyPeriod(routePath, ':studyPeriod');
}
